import { PollingEffects } from './polling/polling.effects';
import { ScannerEffects } from './scanner/scanner.effects';
import { ConfigEffects } from './configuration/config.effects';
import { ResultsEffects } from './session/results.effects';
import { SessionEffects } from './session/session.effects';
import { DiagnosticsEffects } from './diagnostics/diagnostics.effects';
import { PendingEffects } from './pending/pending.effects';

export const effects = [
  ScannerEffects,
  ConfigEffects,
  ResultsEffects,
  PollingEffects,
  SessionEffects,
  DiagnosticsEffects,
  PendingEffects,
];
